import { useState, useEffect } from 'react';

const words = ['siding', 'windows', 'doors', 'roofing', 'trim', 'decking', 'gutters', 'interlock', 'garage doors', 'fascia', 'exterior lighting', 'soffits', 'fencing', 'caulking', 'paint', 'landscaping'];

export const Typewriter = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const word = words[currentWordIndex];
    const typeSpeed = isDeleting ? 50 : 100;
    const pauseDuration = 2000;

    const timer = setTimeout(() => {
      if (!isDeleting) {
        // Typing
        if (currentText.length < word.length) {
          setCurrentText(word.slice(0, currentText.length + 1));
        } else {
          // Pause before deleting
          setTimeout(() => setIsDeleting(true), pauseDuration);
        }
      } else {
        // Deleting
        if (currentText.length > 0) {
          setCurrentText(word.slice(0, currentText.length - 1));
        } else {
          setIsDeleting(false);
          setCurrentWordIndex((prev) => (prev + 1) % words.length);
        }
      }
    }, typeSpeed);

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentWordIndex]);

  return (
    <span className="inline-flex items-baseline">
      <span className="text-[#3b82f6]">{currentText}</span>
      <span className="cursor-blink text-[#3b82f6] ml-0.5">|</span>
    </span>
  );
};

export default Typewriter;
